import { render, staticRenderFns } from "./ObjectActivityBlock.vue?vue&type=template&id=cf0aa71c&scoped=true&"
import script from "./ObjectActivityBlock.vue?vue&type=script&lang=js&"
export * from "./ObjectActivityBlock.vue?vue&type=script&lang=js&"
import style0 from "./ObjectActivityBlock.vue?vue&type=style&index=0&id=cf0aa71c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf0aa71c",
  null
  
)

export default component.exports